import { Injectable } from '@angular/core';
import {
  type ActionEventConfig,
  type GraphActionEvent,
} from '@bizzdesign/modeler/models';
import { Subject } from 'rxjs';

import {
  convertObjectToSemanticalData,
  GraphActionToolbarAdapter,
  type GraphActionToolbarAllowedActions,
} from '@bizzdesign/modeler/utils-modeler';

@Injectable()
export class GraphActionsToolbarService extends GraphActionToolbarAdapter {
  readonly _actionTrigger$ = new Subject<ActionEventConfig>();
  public actionTrigger$ = this._actionTrigger$.asObservable();

  public handleActionEvent(event: GraphActionEvent): void {
    if (event.key in this.adapter) {
      const actionEvent = {
        ...this.adapter[event.key as GraphActionToolbarAllowedActions],
        isDragAndDrop: event.isDragAndDrop,
      };
      if (event.key === 'cancelAction') {
        this._actionTrigger$.next({
          ...this.adapter['cancelAction'],
        });
      } else if (
        event.key === 'createShape' ||
        event.key === 'createFormalShape'
      ) {
        this._actionTrigger$.next({
          ...actionEvent,
          shapeParam: event.shapeParam,
        });
      } else if (
        event.key === 'reuseEntityFromRepo' &&
        !!event.searchResultObject
      ) {
        this._actionTrigger$.next({
          ...actionEvent,
          elementToReuse: convertObjectToSemanticalData(
            event.searchResultObject,
          ),
        });
      } else {
        this._actionTrigger$.next({
          ...actionEvent,
        });
      }
    }
  }
}
